import { render, staticRenderFns } from "./Unpaid.vue?vue&type=template&id=5200f70a"
import script from "./Unpaid.vue?vue&type=script&lang=js"
export * from "./Unpaid.vue?vue&type=script&lang=js"
import style0 from "./Unpaid.vue?vue&type=style&index=0&id=5200f70a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports